export enum GameLayers {
    BlueChest = "BlueMeter",
    YellowChest = "YellowMeter",
    RedChest = "RedMeter",
    Platform = "WoodenPlatform",
    JackpotPlates = "Jackpot",
    JackpotWin = "JackpotWins",
    Replay = "Replay",
    Buffalos = "BuffaloRush",
    EnergyCharge = "EnergyCharge"
}
